import { useEffect, useState } from "react";
import { media } from "../lib/api";
import { useNavigate } from "react-router-dom";

export default function GalleryPreview() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => { media.list("gallery").then(setItems).catch(() => {}); }, []);

  if (items.length === 0) return null;
  const first = items.slice(0, 8);

  return (
    <section data-testid="gallery-preview" className="relative py-24 md:py-32 bg-white">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10 lg:px-16">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-end mb-12 gap-6">
          <div>
            <span className="eyebrow">— Visuals</span>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-ink">Inside the <span className="text-ink">experience</span></h2>
          </div>
          <button data-testid="gallery-view-all" onClick={() => navigate("/gallery")} className="btn-luxe btn-luxe-ghost">View Gallery</button>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-2 md:gap-3">
          {first.map((m, i) => (
            <div
              key={m.id}
              data-testid={`gallery-item-${i}`}
              className="group relative aspect-[4/5] overflow-hidden bg-cream cursor-pointer"
              onClick={() => navigate("/gallery")}
            >
              <img
                src={m.url}
                alt={m.caption || "Onyx"}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-black/0 group-hover:bg-black/25 transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
